function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* @pareto-engineering/generator-front 0.2.4 */
import * as React from 'react';
import PropTypes from 'prop-types';

// Package-level Imports
import styleNames from '@pareto-engineering/bem/exports';
import { LoadingCircle } from "../..";
import { Group } from "./common";
import "./styles.scss";

// Helper Definition
const baseClassName = styleNames.base;
const componentClassName = 'button';
const Button = ({
  id,
  className: userClassName,
  style,
  children,
  isLoading,
  color,
  textColor,
  isCompact,
  isGhost,
  isSimple,
  isGradient,
  isSpaced,
  arrowDirection,
  ...otherProps
}) => {
  const buttonText = isSimple ? /*#__PURE__*/React.createElement("span", {
    className: styleNames.modifierUnderlined
  }, children) : children;
  const {
    disabled,
    ...rest
  } = otherProps;
  return /*#__PURE__*/React.createElement("button", _extends({
    id: id,
    className: [baseClassName, componentClassName, userClassName, `x-${color}`, textColor && `y-${textColor}`, isGhost && styleNames.modifierGhost, isCompact && styleNames.modifierCompact, isSimple && styleNames.modifierSimple, isGradient && styleNames.modifierGradient, isSpaced && styleNames.modifierSpaced, !isLoading && arrowDirection && `arrow-${arrowDirection}`].filter(e => e).join(' '),
    style: style,
    type: "button",
    disabled: disabled || isLoading
  }, rest), isLoading ? /*#__PURE__*/React.createElement(LoadingCircle, {
    style: {
      '--x': 'var(--stroke-color, var(--on-x))'
    },
    heightWidth: "1.15em"
  }) : buttonText);
};
Button.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * Whether the button has the ghost style
   */
  isGhost: PropTypes.bool,
  /**
   * Whether the button is compact
   */
  isCompact: PropTypes.bool,
  /**
   * Whether the button is simple (no borders, only text)
   */
  isSimple: PropTypes.bool,
  /**
   * Should this button have a gradient
   */
  isGradient: PropTypes.bool,
  /**
   * Should this button be spaced
   */
  isSpaced: PropTypes.bool,
  /**
   * The button color
   */
  color: PropTypes.string,
  /**
   * Button loading state
   */
  isLoading: PropTypes.bool,
  /**
   * The direction of the arrow if the button has one
   */
  arrowDirection: PropTypes.string
};
Button.defaultProps = {
  color: 'main'
};
Button.Group = Group;
export default Button;